import { render } from "./num.vue?vue&type=template&id=1b07b9e5"
import script from "./num.vue?vue&type=script&lang=js"
export * from "./num.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__